import React, {CSSProperties, useMemo} from 'react'
import {ResolutionBreak, breakpoints} from './shared'

import {CommonModal} from './CommonModal'
import {useGLTranslation, useResolutionBreak} from './hooks'

interface Props {
  videoId: string
  onClose: () => void
}

export function YoutubeModal({onClose, videoId}: Props) {
  const resBreak = useResolutionBreak()
  const aspectRatioStyle = useMemo(() => {
    return getAspectRatioForResolution(resBreak)
  }, [resBreak])
  const {t} = useGLTranslation()

  return (
    <CommonModal
      onClose={onClose}
      closeStyle="click-away"
      boxStyle={{
        maxWidth: aspectRatioStyle.width,
        maxHeight: aspectRatioStyle.height,
        borderRadius: 0
      }}
      contentContainerStyle={styles.contentContainerOverrides}
    >
      <div style={styles.iframeContainer}>
        <iframe
          style={aspectRatioStyle}
          src={`https://www.youtube.com/embed/${videoId}`}
          title={t('youtubePlayer')}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={true}
        ></iframe>
      </div>
    </CommonModal>
  )
}

function getAspectRatioForResolution(resBreak: ResolutionBreak) {
  const aspectRatio = 16 / 9
  const maxScreenPct = 0.8
  const minWidth = 390

  const width = Math.max(breakpoints[resBreak], minWidth) * maxScreenPct

  return {
    width: `${width}px`,
    height: `${width / aspectRatio}px`
  }
}

const styles: Record<string, CSSProperties> = {
  contentContainerOverrides: {
    padding: 0
  },
  iframeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
}
